import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'

import styles from './styles.module.scss'
import { ButtonContext } from '../Button/ButtonProvider'

const AnimateIconWithText = ({ icon, children, ...props }) => {
  const { isHovering } = useContext(ButtonContext)

  const wrapperStyles = classNames({
    [styles.wrapper]: true,
    [styles.isParentHovering]: isHovering,
  })

  const iconStyles = classNames({
    [styles.icon]: true,
    [styles.iconIsParentHovering]: isHovering,
  })

  return (
    <span {...props} className={wrapperStyles}>
      <FontAwesomeIcon className={iconStyles} icon={icon} />
      {children}
    </span>
  )
}

AnimateIconWithText.defaultProps = {
  icon: 'user-circle',
}

AnimateIconWithText.propTypes = {
  /**
   * Pass Font Awesome Icon that you want displayed
   */
  icon: PropTypes.string,
}

export default AnimateIconWithText
